import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Trash2, Shield, ShieldOff } from "lucide-react";
import { toast } from "sonner";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);

  const load = () => api.get("/admin/users").then((r) => setUsers(r.data));
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!window.confirm("Delete user?")) return;
    await api.delete(`/admin/users/${id}`);
    toast.success("User deleted");
    load();
  };

  const toggleRole = async (u) => {
    const newRole = u.role === "admin" ? "user" : "admin";
    await api.put(`/admin/users/${u.id}`, { role: newRole });
    toast.success(`Role updated to ${newRole}`);
    load();
  };

  const updatePlan = async (u, plan) => {
    await api.put(`/admin/users/${u.id}`, { subscription_plan: plan, subscription_status: plan ? "active" : "inactive" });
    toast.success("Subscription updated");
    load();
  };

  return (
    <div data-testid="admin-users-page">
      <h1 className="text-3xl font-black tracking-tighter mb-1" style={{ fontFamily: "Outfit" }}>Users</h1>
      <p className="text-[#888] text-sm mb-6">{users.length} registered users</p>
      <div className="bg-[#0d0d0d] border border-white/5 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#080808] text-[#888] text-xs uppercase tracking-wider">
            <tr><th className="text-left p-3">Name</th><th className="text-left p-3">Email</th><th className="text-left p-3">Role</th><th className="text-left p-3">Plan</th><th className="text-left p-3">Joined</th><th className="text-right p-3">Actions</th></tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-t border-white/5 hover:bg-white/5">
                <td className="p-3 font-medium">{u.name}</td>
                <td className="p-3 text-[#aaa]">{u.email}</td>
                <td className="p-3">
                  <span className={`text-[10px] px-1.5 py-0.5 rounded font-bold ${u.role === "admin" ? "bg-[#E50914]/20 text-[#E50914]" : "bg-white/10 text-[#aaa]"}`}>{u.role.toUpperCase()}</span>
                </td>
                <td className="p-3">
                  <select value={u.subscription_plan || ""} onChange={(e) => updatePlan(u, e.target.value || null)} className="bg-[#1a1a1a] border border-white/10 rounded px-2 py-1 text-xs" data-testid={`plan-select-${u.id}`}>
                    <option value="">No plan</option>
                    <option value="basic">Basic</option>
                    <option value="standard">Standard</option>
                    <option value="premium">Premium</option>
                  </select>
                </td>
                <td className="p-3 text-[#aaa] text-xs">{u.created_at ? new Date(u.created_at).toLocaleDateString() : "—"}</td>
                <td className="p-3 text-right">
                  <button onClick={() => toggleRole(u)} className="text-[#aaa] hover:text-white p-1" title="Toggle admin" data-testid={`role-toggle-${u.id}`}>
                    {u.role === "admin" ? <ShieldOff size={16} /> : <Shield size={16} />}
                  </button>
                  <button onClick={() => del(u.id)} className="text-[#aaa] hover:text-[#E50914] p-1 ml-1" data-testid={`delete-user-${u.id}`}><Trash2 size={16} /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
